/**
 * Schedules a callback after two animation frames, giving React Native time to
 * finish the current layout pass before measuring (e.g. measureInWindow calls).
 */
export function afterLayout(callback: () => void): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(callback)
  })
}
